import { A4uHelp as IconComponent } from '@adobe/react-spectrum-workflow/dist/Help.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Help(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}